module.exports = __webpack_public_path__ + "img/robot.d54c6d62.png";